import { createVanIconComponent } from "./van"

const Photograph = createVanIconComponent("photograph")
export default Photograph
